import { DEMO_TEMPLATES, type IEmailTemplate } from '../fixtures';
import type { DemoAction } from './actions';

/**
 * Act 5, setup: the outreach templates (NTF). The concern criteria were here until SR-222 put them
 * live (`/team/setup/criteria`), and the role matrix until SR-228 did the roles
 * (`/team/setup/roles`) — "View as role" reads its fixed matrix now (`ROLE_MATRIX`).
 */
export interface IAct5State {
  templates: IEmailTemplate[];
}

export function initialAct5(): IAct5State {
  return {
    templates: DEMO_TEMPLATES.map((template) => ({ ...template }))
  };
}

export function act5Reducer(state: IAct5State, action: DemoAction): IAct5State {
  switch (action.type) {
    case 'template/edit':
      return {
        ...state,
        templates: state.templates.map((template) =>
          template.id === action.id ? { ...template, subject: action.subject, body: action.body } : template
        )
      };
    default:
      return state;
  }
}
